import { render } from "./SystemDashboard.vue?vue&type=template&id=77b6a48c&scoped=true"
import script from "./SystemDashboard.vue?vue&type=script&lang=js"
export * from "./SystemDashboard.vue?vue&type=script&lang=js"

import "./SystemDashboard.vue?vue&type=style&index=0&id=77b6a48c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b6a48c"]])

export default __exports__